import React from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  billCreditExpensesTable,
  billCreditItemsTable,
  billCreditApplyTable,
} from "../../../config/grid-column-defs";
import {
  getTransactionVendorExpenses,
  getTransactionVendorCreditItemDetails,
  getTransactionVendorCreditApply,
} from "../../../api/transaction-type";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, CircularProgress, Tabs, Tab } from "@mui/material";

import TabPanel from "../../../components/TabPanel";

export default function CreditMemoItems() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  const [unappliedData, setUnappliedData] = useState("");
  const [appliedData, setAppliedData] = useState("");

  const [expensesSum, setExpensesSum] = useState("");
  const [itemSum, setItemSum] = useState("");
  const [applySum, setApplySum] = useState("");

  //  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  //  function refreshTable () {
  //      setTableRefreshCount(prev => prev + 1);
  //  }

  async function getTransactionBillCreditExpenseData(limit, offset) {
    try {
      const { data } = await getTransactionVendorExpenses(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setExpensesSum(data?.data?.expensetotal);
      return { rows: data.data.data, total: data.data.dataCount, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }

  async function getTransactionBillCreditItemData(limit, offset) {
    try {
      const { data } = await getTransactionVendorCreditItemDetails(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setItemSum(data.data.itemsum);
      setAppliedData(data.data.applied_amount);
      setUnappliedData(data.data.unapplied_amount);
      return {
        rows: data.data.items,
        total: data.data.itemtotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }

  async function getTransactionBillCreditApplyData(limit, offset) {
    try {
      const { data } = await getTransactionVendorCreditApply(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setApplySum(data.data.sum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  return (
    <>
   { unappliedData &&
      <Box className="viewDetilsBox">
        <Grid container>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">UNAPPLIED</p>
            <p className="tFormName">{unappliedData}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">APPLIED</p>
            <p className="tFormName">{appliedData}</p>
          </Grid>
        </Grid>
      </Box>
}
      <Tabs
        value={tabIndex}
        // onChange={handleChange}
        onChange={(e, nv) => {
          setTabIndex(nv);
        }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className="tabs-sub-bkg"
      >
        <Tab label={`Expenses ${expensesSum || "0.00"}`} />
        <Tab label={`Items ${itemSum || "0.00"}`} />
        <Tab label={`Apply ${applySum || "0.00"}`} />
      </Tabs>

      {/* Expenses */}
      <TabPanel value={tabIndex} index={0}>
        <AgGridPaginatedTable
          getTableRows={getTransactionBillCreditExpenseData}
          columns={billCreditExpensesTable}
          perPage={5}
          refreshCounter={0}
        />
      </TabPanel>
      {/* Expenses */}

      {/* Items */}
      <TabPanel value={tabIndex} index={1}>
        <AgGridPaginatedTable
          getTableRows={getTransactionBillCreditItemData}
          columns={billCreditItemsTable}
          perPage={5}
          refreshCounter={0}
        />
      </TabPanel>
      {/* Items */}

      {/* Apply */}
      <TabPanel value={tabIndex} index={2}>
        <AgGridPaginatedTable
          getTableRows={getTransactionBillCreditApplyData}
          columns={billCreditApplyTable}
          perPage={5}
          refreshCounter={0}
        />
      </TabPanel>
      {/* Apply */}
    </>
  );
}
